// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","596":"component---src-templates-menu-tsx","612":"component---src-templates-content-tsx"}[chunkId] + "-" + {"218":"72aa6114273ce094daf7","596":"69291181d63f596d522d","612":"c34a37111b638cc159ca"}[chunkId] + ".js";
};